type ScriptOptions = {
  id?: string
  async?: boolean
  defer?: boolean
}

export const appendScript = async (url: string, options: ScriptOptions = {}) => {
  return new Promise((resolve) => {
    const { id } = options
    if (id && document.querySelector(`script#${id}`)) {
      // don't add script if already exists
      return resolve(true)
    }
    const script = document.createElement('script')
    if (id) {
      script.id = id
    }
    script.async = !!options.async
    script.defer = !!options.defer
    script.type = 'text/javascript'
    script.src = url
    script.onload = resolve
    document.body.appendChild(script)
  })
}

export const getTemplateData = <T>(selector: string): T | undefined => {
  try {
    const script = document.querySelector(selector)
    const data = script && JSON.parse(script.innerHTML)
    return data && data as T
  } catch (e) {
    console.warn(e)
  }
}

export const getOffsetBottom = (selector: string) => (
  document.querySelector(selector)?.getBoundingClientRect()?.bottom || 0
)


export const scrollToSelector = (selector: string, offset = 0, behavior: ScrollBehavior = 'smooth') => {
  const $el = document.querySelectorAll(selector)?.[0]
  if (!$el) {
    return
  }
  const $announcement = getOffsetBottom('#shopify-section-layout-announcement-bar')
  const $header = getOffsetBottom('#shopify-section-layout-header')
  const $back = getOffsetBottom('#mobile-header-sticky-back')
  offset += Math.max($header - $announcement, $back)
  const top = window.scrollY + $el.getBoundingClientRect().top - offset
  window.scrollTo({ behavior, top })
}

export const scrollToTop = () => window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })

export const scrollIntoView = (selector: string, behavior: ScrollBehavior = 'smooth') => {
  const $el = document.querySelectorAll(selector)?.[0]
  if ($el) {
    $el.scrollIntoView({ behavior })
  }
}